<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline"
    :class="[width, height, color]"
    viewBox="0 0 14 14"
  >
    <path
      id="Path_3573"
      data-name="Path 3573"
      d="M19,6.41,17.59,5,12,10.59,6.41,5,5,6.41,10.59,12,5,17.59,6.41,19,12,13.41,17.59,19,19,17.59,13.41,12Z"
      transform="translate(-5 -5)"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-10'
    },
    height: {
      type: String,
      default: 'h-10'
    },
    color: {
      type: String,
      default: '#ac4a03'
    }
  }
}
</script>

<style></style>
